import { useState } from 'react';

import Checkbox from '@cartwhl/ui/atoms/Checkbox';
import Input from '@cartwhl/ui/atoms/Input';
import LogoMark from '@cartwhl/ui/atoms/LogoMark';
import Text from '@cartwhl/ui/base/Text';
import GoButton from '@cartwhl/ui/input/GoButton';

import { noticesStore, userStore } from 'stores/global';

export default function SpinGiverPage() {
  const defaultExpiry = new Date();
  defaultExpiry.setMonth(defaultExpiry.getMonth() + 1);

  const [loading, setLoading] = useState(false);
  const [userIdentifier, setUserIdentifier] = useState('');
  const [spinAmount, setSpinAmount] = useState('1000');
  const [premiumAccess, setPremiumAccess] = useState(false);
  const [premiumAccessUntil, setPremiumAccessUntil] = useState(
    defaultExpiry.toISOString().split('T')[0],
  );

  const handlePremiumAccessChange = async (premiumAccess: boolean) => {
    if (!premiumAccess) {
      setPremiumAccessUntil(defaultExpiry.toISOString().split('T')[0]);
    }

    setPremiumAccess(premiumAccess);
  };

  const handleMakeNewAPIKey = async () => {
    const result = await userStore.createNewServiceAccount();
    console.log(result);
    noticesStore.success(
      'Service account created successfully, check your console log for the key!',
    );
  };

  const handleSubmit = async () => {
    if (!userIdentifier || (!spinAmount && !premiumAccessUntil)) {
      noticesStore.error('Please fill in all fields');
      return;
    }

    setLoading(true);

    // Extend by 1 day to make the expiry date inclusive (the default time is 00:00:00)
    const extendedPremiumAccessUntil = new Date(premiumAccessUntil);
    extendedPremiumAccessUntil.setDate(
      extendedPremiumAccessUntil.getDate() + 1,
    );

    try {
      const result = await userStore.addProducts(
        userIdentifier,
        parseInt(spinAmount),
        premiumAccess ? extendedPremiumAccessUntil.toISOString() : undefined,
      );
      if (result) {
        noticesStore.success('Products added successfully!');
        setUserIdentifier('');
        setPremiumAccess(false);
        setSpinAmount('1000');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto flex w-full max-w-[480px] flex-col justify-center px-8 py-10 xl:max-w-[576px] xl:px-20">
      <LogoMark className="mb-11 h-10 w-10 md:h-12 md:w-12" />
      <Text as="h1" variant="web/display/lg" className="mb-6">
        Spin Giver
      </Text>

      <div className="flex flex-col gap-4">
        <Input
          name="userIdentifier"
          label="User ID or Email Address for recipient"
          placeholder="Enter user ID or email address"
          value={userIdentifier}
          onChange={(e) => setUserIdentifier(e.target.value)}
        />

        <Input
          name="spinAmount"
          label="Number of Spins"
          type="number"
          placeholder="Enter number of spins"
          value={spinAmount}
          onChange={(e) => setSpinAmount(e.target.value)}
        />

        {premiumAccess && (
          <Input
            name="premiumAccessUntil"
            label="Premium Access Until"
            value={premiumAccessUntil}
            type="date"
            min={new Date().toISOString().split('T')[0]} // Disable past dates
            onChange={(e) => setPremiumAccessUntil(e.target.value)}
          />
        )}

        <Checkbox
          id="premium-checkbox"
          checked={premiumAccess}
          label="Upgrade to Premium"
          variant="checkbox"
          setChecked={handlePremiumAccessChange}
        />

        <GoButton
          onClick={handleSubmit}
          loading={loading}
          type="submit"
          className="col-span-2"
        >
          Add
        </GoButton>

        <GoButton
          onClick={handleMakeNewAPIKey}
          variant="pose"
          loading={loading}
          type="submit"
          className="col-span-2"
        >
          (Test) Make a new API Key
        </GoButton>
      </div>
    </div>
  );
}
